import Vue from 'vue'

//引入自定义图片组件
import Pagination from '@/components/Pagination'
Vue.component('Pagination', Pagination)
//引入自定义图片组件
import MyImage from '@/components/MyImage'
Vue.component('MyImage', MyImage)
//引入自定义标签组件
import Tabs from '@/components/Tabs'
Vue.component('Tabs', Tabs)
//引入自定义Dialog组件
import CustomDialog from '@/components/CustomDialog'
Vue.component('CustomDialog', CustomDialog)
//引入自定义Dialog组件
import CustomFilter from '@/components/CustomFilter'
Vue.component('CustomFilter', CustomFilter)
//引入自定义上传组件
import Uploader from '@/components/Uploader'
Vue.component('Uploader', Uploader)
import NoDataCell from '@/components/TableCell/NoData'
Vue.component('NoDataCell', NoDataCell)
import ImgTableCell from '@/components/TableCell/Img'
Vue.component('ImgTableCell', ImgTableCell)
import FileCell from '@/components/TableCell/FileCell'
Vue.component('FileCell', FileCell)
import TableImg from '@/components/TableCell/TableImg'
Vue.component('TableImg', TableImg)




// WEBPACK FOOTER //
// ./src/plugins.js